import React from 'react'

const FacilityReports = () => {
  return (
    <div>FacilityReports</div>
  )
}

export default FacilityReports